<template>
    <v-form ref="form">
        <v-row v-if="!editMode">
            <v-col>
                <v-text-field
                    label="Code"
                    v-model="form.code"
                    :rules="[isRequired]"
                    outlined
                    hide-details="auto"
                    dense
                    background-color="white">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    label="Name"
                    v-model="form.name"
                    :rules="[isRequired]"
                    outlined
                    hide-details="auto"
                    dense
                    background-color="white">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row v-if="isRoot && !editMode">
            <v-col>
                <v-autocomplete
                    label="Default Inventory Account"
                    v-model="form.inventory_account_id"
                    outlined
                    clearable
                    dense
                    hide-details="auto"
                    @update:search-input="searchAccounts"
                    :items="accounts"
                    item-text="display_name"
                    item-value="id"
                    :rules="[isRequired]"
                ></v-autocomplete>
            </v-col>
        </v-row>
        <v-row v-if="!isRoot && !editMode">
            <v-col>
                <v-autocomplete
                    label="Parent"
                    outlined
                    clearable
                    dense
                    disabled
                    item-text="display_name"
                    item-value="id"
                    :rules="[isRequired]"
                    v-model="form.parent_id"
                    hide-details="auto"
                    :items="itemGroups"
                    @update:search-input="itemGroupsSearch"
                    >
                </v-autocomplete>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { isRequired } from './../../utils/validations';
import accountsService from "./../../services/stock/account";

export default {
    name: "ItemGroupForm",
    props: {
        value: Object,
        isRoot: Boolean,
        editMode: Boolean
    },
    data() {
        return {
            form: {
                name: "",
                code: "",
                parent_id: null,
                inventory_account_id: null
            },
            accounts: [],
            accountsLoading: []
        }
    },
    computed: {
        ...mapGetters({
            itemGroups: "stock/itemGroup/search/data"
        })
    },
    watch: {
        form: {
            deep: true,
            handler(form) {
                this.$emit("input", {...form});
            }
        }
    },
    methods: {
        isRequired,
        ...mapActions({
            itemGroupsSearch: "stock/itemGroup/search/get"
        }),
        validate() {
            return this.$refs.form.validate();
        },
        searchAccounts(query) {
            this.accountsLoading = true;
            accountsService.search(query).then(res => {
                this.accounts = [...this.accounts, ...res.data]
            }).finally(() => {
                this.accountsLoading = false;
            })
        }
    },
    mounted() {
        this.form = { ...this.form, ...this.value}
    }
}
</script>

<style>

</style>